import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import styles from "./mainLayout.module.scss";
import { useGetPermissionsQuery } from "store/services/users/account";
import LoadingIndicator from "components/shared/LoadingIndicator";
import SidebarNew from "components/Header/sidebar/SidebarNew";
import Sidebar from "components/Header/sidebar/Sidebar";
import { useGetProfileQuery } from "store/services/profile";
import { useSelector } from "react-redux";
import useNotificationSocket from "utils/socket/useNotificationSocket";

const MainLayout = () => {
  const userInfo = useSelector((state) => state.auth.userInfo)
  const token = useSelector((state) => state.auth.token);
  const navigate = useNavigate()

  useNotificationSocket(token);

  const [sidebar, setSidebar] = useState();
  const { isFetching: permissionsLoading } = useGetPermissionsQuery();
  // DO NOT REMOVE THIS PROFILE DETAILS API, IT IS USED FOR USER PERMISSIONS IN REDUX
  const { data: profileDetails, isLoading: getProfileLoading, isFetching: getProfileFetching } = useGetProfileQuery();

  useEffect(() => {
    console.log(userInfo)
    if (userInfo?.role?.slug === "sub_admin" && !userInfo?.is_on_board_complete) {
      navigate('/sub-admin/onboard')
    } 
  }, [userInfo])

  document.title = "Khan - Admin  "
  if (permissionsLoading) {
    return <LoadingIndicator />
  }

  return (
    <>
      <div className={`${styles.mainLayout} d-flex align-items-start`}>
        {/* <Sidebar sidebar={sidebar} setSidebar={setSidebar} /> */}
        <SidebarNew sidebar={sidebar} setSidebar={setSidebar} />
        <main
          className={`${styles.MainBody} ms-auto MainBody position-relative`}
        >
          <Header sidebar={sidebar} setSidebar={setSidebar} />
          <Outlet />
        </main>
      </div>
    </>
  );
};
export default MainLayout;
